module.exports = __webpack_public_path__ + "assets/img/investmentAssistant-advantage-bg.adeab416.png";